const NUMPY_DTYPES = {
    int32: Int32Array,
    int16: Int16Array,
    int8: Int8Array,
    uint32: Uint32Array,
    uint16: Uint16Array,
    uint8: Uint8Array,
    float32: Float32Array,
    float64: Float64Array,
};

export { NUMPY_DTYPES };
